import { render } from "./BenutzerListe.vue?vue&type=template&id=4a0f6594&ts=true"
import script from "./BenutzerListe.vue?vue&type=script&lang=ts"
export * from "./BenutzerListe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__